import { atom } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";
import type { AuthCustomer } from "@/api/auth/auth.types";

export const isAuthAtom = atomWithStorage<boolean>("munchi-auth", false);
export const currentUserAtom = atomWithStorage<AuthCustomer | null>(
  "munchi-user",
  null,
);
export const completeProfileSheetOpenAtom = atom<boolean>(false);
export const completeProfileOnConfirmAtom = atom<(() => void) | null>(null);
// Short-lived in-memory token proving OTP was verified for a new phone user.
// Cleared after completeProfile succeeds or on logout.
export const phoneVerifiedTokenAtom = atom<string | null>(null);

export interface GuestDetails {
  firstName: string;
  lastName: string;
  email: string;
  countryCode: string;
  phoneNumber: string;
}

const guestDetailsSessionStorage = createJSONStorage<GuestDetails | null>(
  () => window.sessionStorage,
);
export const guestDetailsAtom = atomWithStorage<GuestDetails | null>(
  "munchi-guest",
  null,
  guestDetailsSessionStorage,
);
